import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from "react-moment";
import {
  getMessagesById,
  getUsers,
  createMessage,
  deleteMessage,
  deleteAllMessages,
  deleteConversation,
  clearUsers,
} from "../../../actions/message";
import { getGifs, getGifsSearch } from "../../../actions/gif";

import GifItem from "../IME/GifItem";
import MessageUserItem from "../IME/MessageUserItem";
import MessageUserListItem from "../IME/MessageUserListItem";

import VolumeGreen from "../Innovators/VolumeGreen";
import ProgressGreen from "../Innovators/ProgressGreen";
import ToggleButton from "../../PlayerButtons/ToggleButton";

const MessageEmployerUsers = ({
  auth: { user },
  message: { messages, message, users },
  getMessagesById,
  getUsers,
  clearUsers,
  createMessage,
  deleteMessage,
  deleteAllMessages,
  deleteConversation,
  getGifs,
  getGifsSearch,
  gif: { gifs, loading },
  setoverlay,
}) => {
  const [convosoverlay, setconvosoverlay] = useState(false);
  const [showGIFs, setshowGIFs] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [showOverlay, setshowOverlay] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [text, setText] = useState("");
  const [textValue, setTextValue] = useState("");
  const [textMessage, setTextMessage] = useState({
    text: "",
    media: "",
    mediaDataFile: "",
    gif: "",
  });
  const [userObject, setUserObject] = useState({
    user: "",
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    companyname: "",
    jobtitle: "",
    location: {
      state: "",
      city: "",
    },
    messages: [],
  });
  const [chatMessage, setMessage] = useState("");
  const [chatMessages, setMessages] = useState([]);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_green.png");
  const videoRef = useRef(null);
  const divRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    getMessagesById();
    getGifs();
    getGifsSearch();
  }, [getMessagesById, getGifs, getGifsSearch]);

  useEffect(() => {
    getUsers(textValue);
  }, [textValue]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  const inputRef = useRef(null);

  useEffect(() => {
    const div = divRef.current;
    if (!div) return;

    div.scrollTo(0, document.body.scrollHeight * 10000000000000);
  });
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="relative-button-container"></div>
        {!convosoverlay && (
          <div className="messages-box">
            <div className="close-x-alt" onClick={() => setoverlay(false)}>
              <i className="far fa-times-circle fa-3x blue"></i>
            </div>
            <div className="label-input-container">
              <div className="input-drop-down">
                <form
                  className="search-input-hidden"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (textValue !== "") {
                      getUsers(textValue);
                    }
                    setTextValue("");
                  }}
                >
                  <input
                    className="search-input-style"
                    type="text"
                    name="messages"
                    value={textValue}
                    onChange={(e) => setTextValue(e.target.value)}
                    placeholder="Search here to message users"
                  />
                  <button
                    className="search-button background-blue"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (textValue !== "") {
                        getUsers(textValue);
                      }
                      setTextValue("");
                    }}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </form>
              </div>
            </div>
            <p
              className={
                users && users.length <= 0
                  ? "messages-list-messages blue bold"
                  : "messages-list blue bold"
              }
              onClick={() => setconvosoverlay(true)}
            >
              View recent conversations
            </p>
            {users && users.length > 0 ? (
              <section className="friends-section">
                <div className="user-section-name">
                  <i className="fas fa-users fa-2x mr-5 blue"></i>
                  <p className="section-name">
                    Results
                    <span className="mx-5 blue"></span>
                  </p>
                </div>
                <div className="friend-results">
                  {users &&
                    users.map((user) => {
                      return (
                        <MessageUserItem
                          user={user}
                          key={user.user}
                          setUserObject={setUserObject}
                          setconvosoverlay={setconvosoverlay}
                          messages={messages}
                        />
                      );
                    })}
                </div>
              </section>
            ) : (
              <p className="empty-content-alt-dark blue bold">
                No Matched Results
              </p>
            )}
          </div>
        )}
        <div className="relative-button-container"></div>
        {convosoverlay && (
          <div className="messages-box-convos">
            <div
              className="close-x-alt"
              onClick={() => {
                setUserObject({
                  user: "",
                  role: "",
                  channelid: "",
                  avatar: "",
                  firstname: "",
                  lastname: "",
                  companyname: "",
                  jobtitle: "",
                  location: {
                    state: "",
                    city: "",
                  },
                  messages: [],
                });
                clearUsers();
                setconvosoverlay(false);
              }}
            >
              <i className="far fa-times-circle fa-3x blue"></i>
            </div>
            <div className="message-body">
              <div className="message-list-container">
                <div className="user-section-name">
                  <i className="far fa-comments fa-2x mr-5 blue"></i>
                  <p className="section-name">
                    Messages
                    {messages && messages.length > 0 && (
                      <span
                        className="clear-messages mx-5 blue"
                        onClick={() => {
                          deleteAllMessages();
                        }}
                      >
                        <i className="far fa-times-circle mx-5"></i>Clear All
                      </span>
                    )}
                  </p>
                </div>
                {messages && messages.length > 0 ? (
                  <div className="message-list">
                    {messages &&
                      messages.map((message) => {
                        return (
                          <MessageUserListItem
                            message={message}
                            key={message.user}
                            setUserObject={setUserObject}
                            deleteConversation={deleteConversation}
                          />
                        );
                      })}
                  </div>
                ) : (
                  <p className="empty-content-alt-dark-messages blue bold">
                    No Messages
                  </p>
                )}
              </div>
              <div className="message-convo">
                {userObject.firstname === "" && (
                  <div className="empty-side-container-messages">
                    <p className="empty-content-alt-dark-messages blue bold">
                      No Selected Conversations
                    </p>
                  </div>
                )}
                {userObject.firstname !== "" && (
                  <div>
                    {userObject && userObject.role === "innovator" && (
                      <div className="message-user">
                        <div className="message-user-avi-container">
                          <div className="avi-color-border green">
                            <img
                              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                                userObject && userObject.avatar
                              }`}
                              className="message-user-avi"
                            />
                          </div>
                        </div>
                        <div className="message-info-items">
                          <div className="flex-only">
                            <li className="name-font green bold">
                              {userObject && userObject.channelid}
                            </li>
                          </div>
                          <li className="message-info-item">
                            {userObject && userObject.firstname}{" "}
                            {userObject && userObject.lastname}
                          </li>
                          <li className="message-info-item">
                            {userObject && userObject.jobtitle}
                          </li>
                          <li className="message-info-item">
                            {userObject && userObject.location.city},{" "}
                            {userObject && userObject.location.state}
                          </li>
                        </div>
                      </div>
                    )}
                    {userObject && userObject.role === "mentor" && (
                      <div className="message-user">
                        <div className="message-user-avi-container">
                          <div className="avi-color-border red">
                            <img
                              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                                userObject && userObject.avatar
                              }`}
                              className="message-user-avi"
                            />
                          </div>
                        </div>
                        <div className="message-info-items">
                          <div className="flex-only">
                            <li className="name-font red bold">
                              {userObject && userObject.firstname}{" "}
                              {userObject && userObject.lastname}
                            </li>
                          </div>
                          <li className="message-info-item">
                            {userObject && userObject.jobtitle}
                          </li>
                          <li className="message-info-item">
                            {userObject && userObject.location.city},{" "}
                            {userObject && userObject.location.state}
                          </li>
                        </div>
                      </div>
                    )}
                    {userObject && userObject.role === "employer" && (
                      <div className="message-user">
                        <div className="message-user-avi-container">
                          <div className="avi-color-border blue">
                            <img
                              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                                userObject && userObject.avatar
                              }`}
                              className="message-user-avi"
                            />
                          </div>
                        </div>
                        <div className="message-info-items">
                          <div className="flex-only">
                            <li className="name-font blue bold">
                              {userObject && userObject.companyname}
                            </li>
                          </div>
                          <li className="message-info-item">
                            {userObject && userObject.firstname}{" "}
                            {userObject && userObject.lastname}
                          </li>
                          <li className="message-info-item">
                            {userObject && userObject.location.city},{" "}
                            {userObject && userObject.location.state}
                          </li>
                        </div>
                      </div>
                    )}
                    <div className="conversation-container" ref={divRef}>
                      {messages &&
                        messages.length > 0 &&
                        messages
                          .slice(0)
                          .reverse()
                          .map((message) => {
                            if (message.channelid === userObject.channelid) {
                              return message.messages
                                .slice(0)
                                .reverse()
                                .map((message) => {
                                  return (
                                    <div key={message._id}>
                                      {message.sender === user.channelid &&
                                        message.role === "innovator" && (
                                          <div className="conversation-message-container">
                                            <div className="sent-message">
                                              <div className="conversation-avi-container">
                                                <div className="avi-color-border green">
                                                  <img
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                                                    className="conversation-avi"
                                                  />
                                                </div>
                                              </div>
                                              <div className="conversation-text-container">
                                                {message.image !== "" && (
                                                  <img
                                                    className="selected-gif-message"
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/messages_media/${message.image}`}
                                                  />
                                                )}
                                                {message.video !== "" && (
                                                  <div className="relative-button-container">
                                                    <div
                                                      className={
                                                        showOverlay
                                                          ? "alt-video-overlay-messages"
                                                          : "alt-video-overlay-pause-messages"
                                                      }
                                                    >
                                                      <div className="left-controls">
                                                        <ul className="controls">
                                                          <VolumeGreen
                                                            className="Rac__volume"
                                                            initial={0}
                                                            onChange={(
                                                              level
                                                            ) => {
                                                              const volume =
                                                                level / 100;
                                                              videoRef.current.volume =
                                                                volume;
                                                              videoRef.current.muted =
                                                                volume === 0;
                                                            }}
                                                          />
                                                        </ul>
                                                      </div>
                                                      <ToggleButton
                                                        className="alt-center-controls"
                                                        value={() =>
                                                          videoRef.current &&
                                                          !videoRef.current
                                                            .paused
                                                        }
                                                        onChange={(active) => {
                                                          if (!active) {
                                                            return videoRef.current.pause();
                                                          }

                                                          return videoRef.current.play();
                                                        }}
                                                      >
                                                        {(active) => {
                                                          if (
                                                            currentTime > 0.1 &&
                                                            currentTime <
                                                              duration &&
                                                            active
                                                          ) {
                                                            setshowOverlay(
                                                              true
                                                            );
                                                            return (
                                                              <i
                                                                className="far fa-pause-circle green fa-2x"
                                                                onClick={() => {
                                                                  videoRef.current.pause();
                                                                }}
                                                              ></i>
                                                            );
                                                          } else {
                                                            setshowOverlay(
                                                              false
                                                            );
                                                          }
                                                          if (
                                                            currentTime ===
                                                            duration
                                                          ) {
                                                            setCurrentTime(0);
                                                          } else if (
                                                            currentTime === 0 &&
                                                            !active
                                                          ) {
                                                            return (
                                                              <i
                                                                className="far fa-play-circle green fa-2x"
                                                                onClick={() => {
                                                                  videoRef.current.play();
                                                                }}
                                                              ></i>
                                                            );
                                                          }
                                                          return (
                                                            <i
                                                              className="far fa-play-circle green fa-2x"
                                                              onClick={() => {
                                                                videoRef.current.play();
                                                              }}
                                                            ></i>
                                                          );
                                                        }}
                                                      </ToggleButton>
                                                      {/* <ProgressGreen
                                                className="Rac__progress-bar"
                                                initial={0}
                                                time={currentTime}
                                                duration={duration}
                                                onSkip={(time) =>
                                                  (videoRef.current.currentTime =
                                                    time)
                                                }
                                              /> */}
                                                    </div>
                                                    <video
                                                      ref={videoRef}
                                                      className="selected-gif-message"
                                                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/messages_media/${message.video}`}
                                                    ></video>
                                                  </div>
                                                )}
                                                {message.gif !== "" && (
                                                  <img
                                                    className="selected-gif-message"
                                                    src={message.gif}
                                                  />
                                                )}
                                                {(message.text !== "" &&
                                                  message.image !== "") ||
                                                (message.text !== "" &&
                                                  message.video !== "") ||
                                                (message.text !== "" &&
                                                  message.gif !== "") ? (
                                                  <div className="flex-only">
                                                    <p className="conversation-text">
                                                      {message.text}
                                                    </p>
                                                  </div>
                                                ) : (
                                                  <div className="flex-only">
                                                    {message.text !== "" && (
                                                      <p className="conversation-text-alt">
                                                        {message.text}
                                                      </p>
                                                    )}
                                                  </div>
                                                )}
                                                <div className="message-date-container white">
                                                  <i className="far fa-clock message-date green"></i>
                                                  <Moment format="LLLL">
                                                    {message.date}
                                                  </Moment>
                                                </div>
                                              </div>
                                              <div className="flex-only-message">
                                                {showMessageModal && (
                                                  <div className="modal-alt">
                                                    <ul className="modal-items-alt">
                                                      <li
                                                        className="modal-item-alt white"
                                                        onClick={() => {
                                                          deleteMessage(
                                                            message._id,
                                                            message.user
                                                          );
                                                        }}
                                                      >
                                                        <i className="fas fa-times mx-5 red"></i>
                                                        Delete
                                                      </li>
                                                    </ul>
                                                  </div>
                                                )}
                                                <div>
                                                  <i
                                                    className="fas fa-ellipsis-v fa-lg green cursor"
                                                    onClick={() => {
                                                      if (showMessageModal) {
                                                        setShowMessageModal(
                                                          false
                                                        );
                                                      } else {
                                                        setShowMessageModal(
                                                          true
                                                        );
                                                      }
                                                    }}
                                                  ></i>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {message.sender === user.channelid &&
                                        message.role === "mentor" && (
                                          <div className="conversation-message-container">
                                            <div className="sent-message">
                                              <div className="conversation-avi-container">
                                                <div className="avi-color-border red">
                                                  <img
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                                                    className="conversation-avi"
                                                  />
                                                </div>
                                              </div>
                                              <div className="conversation-text-container">
                                                <p className="conversation-text red-border">
                                                  {message.text}
                                                </p>
                                                <div className="message-date-container white">
                                                  <i className="far fa-clock message-date red"></i>
                                                  <Moment format="LLLL">
                                                    {message.date}
                                                  </Moment>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {message.sender === user.channelid &&
                                        message.role === "employer" && (
                                          <div className="conversation-message-container">
                                            <div className="sent-message">
                                              <div className="conversation-avi-container">
                                                <div className="avi-color-border blue">
                                                  <img
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                                                    className="conversation-avi"
                                                  />
                                                </div>
                                              </div>
                                              <div className="conversation-text-container">
                                                <p className="conversation-text blue-border">
                                                  {message.text}
                                                </p>
                                                <div className="message-date-container white">
                                                  <i className="far fa-clock message-date blue"></i>
                                                  <Moment format="LLLL">
                                                    {message.date}
                                                  </Moment>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {message.recipient === user.channelid &&
                                        message.role === "innovator" && (
                                          <div className="conversation-message-container">
                                            <div className="received-message">
                                              <div className="conversation-avi-container">
                                                <div className="avi-color-border green">
                                                  <img
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.recipientavatar}`}
                                                    className="conversation-avi"
                                                  />
                                                </div>
                                              </div>
                                              <div className="conversation-text-container">
                                                {message.image !== "" && (
                                                  <img
                                                    className="selected-gif-message"
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/messages_media/${message.image}`}
                                                  />
                                                )}
                                                {message.video !== "" && (
                                                  <div className="relative-button-container">
                                                    <div
                                                      className={
                                                        showOverlay
                                                          ? "alt-video-overlay-messages"
                                                          : "alt-video-overlay-pause-messages"
                                                      }
                                                    >
                                                      <div className="left-controls">
                                                        <ul className="controls">
                                                          <VolumeGreen
                                                            className="Rac__volume"
                                                            initial={0}
                                                            onChange={(
                                                              level
                                                            ) => {
                                                              const volume =
                                                                level / 100;
                                                              videoRef.current.volume =
                                                                volume;
                                                              videoRef.current.muted =
                                                                volume === 0;
                                                            }}
                                                          />
                                                        </ul>
                                                      </div>
                                                      <ToggleButton
                                                        className="alt-center-controls"
                                                        value={() =>
                                                          videoRef.current &&
                                                          !videoRef.current
                                                            .paused
                                                        }
                                                        onChange={(active) => {
                                                          if (!active) {
                                                            return videoRef.current.pause();
                                                          }

                                                          return videoRef.current.play();
                                                        }}
                                                      >
                                                        {(active) => {
                                                          if (
                                                            currentTime > 0.1 &&
                                                            currentTime <
                                                              duration &&
                                                            active
                                                          ) {
                                                            setshowOverlay(
                                                              true
                                                            );
                                                            return (
                                                              <i
                                                                className="far fa-pause-circle green fa-2x"
                                                                onClick={() => {
                                                                  videoRef.current.pause();
                                                                }}
                                                              ></i>
                                                            );
                                                          } else {
                                                            setshowOverlay(
                                                              false
                                                            );
                                                          }
                                                          if (
                                                            currentTime ===
                                                            duration
                                                          ) {
                                                            setCurrentTime(0);
                                                          } else if (
                                                            currentTime === 0 &&
                                                            !active
                                                          ) {
                                                            return (
                                                              <i
                                                                className="far fa-play-circle green fa-2x"
                                                                onClick={() => {
                                                                  videoRef.current.play();
                                                                }}
                                                              ></i>
                                                            );
                                                          }
                                                          return (
                                                            <i
                                                              className="far fa-play-circle green fa-2x"
                                                              onClick={() => {
                                                                videoRef.current.play();
                                                              }}
                                                            ></i>
                                                          );
                                                        }}
                                                      </ToggleButton>
                                                      {/* <ProgressGreen
                                                className="Rac__progress-bar"
                                                initial={0}
                                                time={currentTime}
                                                duration={duration}
                                                onSkip={(time) =>
                                                  (videoRef.current.currentTime =
                                                    time)
                                                }
                                              /> */}
                                                    </div>
                                                    <video
                                                      ref={videoRef}
                                                      className="selected-gif-message"
                                                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/messages_media/${message.video}`}
                                                    ></video>
                                                  </div>
                                                )}
                                                {message.gif !== "" && (
                                                  <img
                                                    className="selected-gif-message"
                                                    src={message.gif}
                                                  />
                                                )}
                                                {(message.text !== "" &&
                                                  message.image !== "") ||
                                                (message.text !== "" &&
                                                  message.video !== "") ||
                                                (message.text !== "" &&
                                                  message.gif !== "") ? (
                                                  <div className="flex-only">
                                                    <p className="conversation-text">
                                                      {message.text}
                                                    </p>
                                                  </div>
                                                ) : (
                                                  <div className="flex-only">
                                                    {message.text !== "" && (
                                                      <p className="conversation-text-alt">
                                                        {message.text}
                                                      </p>
                                                    )}
                                                  </div>
                                                )}
                                                <div className="message-date-container white">
                                                  <i className="far fa-clock message-date green"></i>
                                                  <Moment format="LLLL">
                                                    {message.date}
                                                  </Moment>
                                                </div>
                                              </div>
                                              <div className="flex-only-message">
                                                {showModal && (
                                                  <div className="modal-alt">
                                                    <ul className="modal-items-alt">
                                                      <li className="modal-item-alt white">
                                                        <i className="fas fa-flag mx-5 green"></i>
                                                        Report
                                                      </li>
                                                      <li className="modal-item-alt white">
                                                        <i className="fas fa-ban mx-5 red"></i>
                                                        Block
                                                      </li>
                                                      <li
                                                        className="modal-item-alt white"
                                                        onClick={() => {
                                                          deleteMessage(
                                                            message._id,
                                                            message.user
                                                          );
                                                        }}
                                                      >
                                                        <i className="fas fa-times mx-5 red"></i>
                                                        Delete
                                                      </li>
                                                    </ul>
                                                  </div>
                                                )}
                                                <div>
                                                  <i
                                                    className="fas fa-ellipsis-v fa-lg green cursor"
                                                    onClick={() => {
                                                      if (showModal) {
                                                        setShowModal(false);
                                                      } else {
                                                        setShowModal(true);
                                                      }
                                                    }}
                                                  ></i>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {message.recipient === user.channelid &&
                                        message.role === "mentor" && (
                                          <div className="conversation-message-container">
                                            <div className="received-message">
                                              <div className="conversation-avi-container">
                                                <div className="avi-color-border red">
                                                  <img
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.recipientavatar}`}
                                                    className="conversation-avi"
                                                  />
                                                </div>
                                              </div>
                                              <div className="conversation-text-container">
                                                <p className="conversation-text red-border">
                                                  {message.text}
                                                </p>
                                                <div className="message-date-container white">
                                                  <i className="far fa-clock message-date red"></i>
                                                  <Moment format="LLLL">
                                                    {message.date}
                                                  </Moment>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {message.recipient === user.channelid &&
                                        message.role === "employer" && (
                                          <div className="conversation-message-container">
                                            <div className="received-message">
                                              <div className="conversation-avi-container">
                                                <div className="avi-color-border blue">
                                                  <img
                                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.recipientavatar}`}
                                                    className="conversation-avi"
                                                  />
                                                </div>
                                              </div>
                                              <div className="conversation-text-container">
                                                <p className="conversation-text blue-border">
                                                  {message.text}
                                                </p>
                                                <div className="message-date-container white">
                                                  <i className="far fa-clock message-date blue"></i>
                                                  <Moment format="LLLL">
                                                    {message.date}
                                                  </Moment>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  );
                                });
                            }
                          })}
                    </div>
                    <div className="create-message-container">
                      {gifs && textMessage.gif !== "" && (
                        <div className="selected-gif-container-alt">
                          <img
                            className="selected-gif-alt"
                            src={gifs && textMessage.gif}
                          />
                          <i
                            className="far fa-times selected-gif-x"
                            onClick={() => {
                              setTextMessage({ ...textMessage, gif: "" });
                              setshowGIFs(false);
                            }}
                          ></i>
                          <p className="text-message white">
                            {textMessage.text}
                          </p>
                        </div>
                      )}
                      {textMessage.mediaDataFile !== "" &&
                        textMessage.media.type == "image/jpeg" && (
                          <div className="selected-gif-container-alt">
                            <img
                              className="selected-gif-alt"
                              src={textMessage.mediaDataFile}
                            />
                            <i
                              className="far fa-times selected-gif-x"
                              onClick={() => {
                                setTextMessage({
                                  ...textMessage,
                                  mediaDataFile: "",
                                });
                                setShowMedia(false);
                              }}
                            ></i>
                            <p className="text-message white">
                              {textMessage.text}
                            </p>
                          </div>
                        )}
                      {textMessage.mediaDataFile !== "" &&
                        textMessage.media.type == "video/mp4" && (
                          <div className="selected-gif-container-alt">
                            <div className={"alt-video-overlay-volume"}>
                              <div className="alt-left-controls">
                                <ul className="controls">
                                  <VolumeGreen
                                    className="Rac__volume"
                                    onChange={(level) => {
                                      const volume = level / 100;
                                      videoRef.current.volume = volume;
                                      videoRef.current.muted = volume === 0;
                                    }}
                                  />
                                </ul>
                              </div>
                            </div>
                            <video
                              ref={videoRef}
                              className="selected-gif-alt"
                              src={textMessage.mediaDataFile}
                              autoPlay={true}
                              loop
                            ></video>
                            <i
                              className="far fa-times selected-gif-x"
                              onClick={() => {
                                setTextMessage({
                                  ...textMessage,
                                  mediaDataFile: "",
                                });
                                setShowMedia(false);
                              }}
                            ></i>
                            <p className="text-message white">
                              {textMessage.text}
                            </p>
                          </div>
                        )}
                      <input
                        ref={inputRef}
                        name="message"
                        value={textMessage.text}
                        onChange={(e) =>
                          setTextMessage({
                            ...textMessage,
                            text: e.target.value,
                          })
                        }
                        className="messages-input"
                        placeholder="Enter Message"
                        onKeyPress={
                          textMessage.text !== "" ||
                          textMessage.media !== "" ||
                          textMessage.gif !== ""
                            ? (e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  createMessage(textMessage, userObject.user);
                                  setTextMessage({
                                    text: "",
                                    media: "",
                                    mediaDataFile: "",
                                    gif: "",
                                  });
                                  setshowGIFs(false);
                                  inputRef.current.focus();
                                }
                              }
                            : null
                        }
                      />
                      {!showGIFs &&
                        textMessage.gif === "" &&
                        textMessage.mediaDataFile === "" && (
                          <div
                            className="gif-button-container"
                            onClick={() => setShowMedia(true)}
                          >
                            <label
                              htmlFor="media"
                              className="setup-image-container"
                            >
                              <i className="fas fa-photo-video fa-2x mx-5 green cursor"></i>
                            </label>
                            <input
                              type="file"
                              name="media"
                              id="media"
                              className="file-upload"
                              multiple
                              onChange={(e) => {
                                setTextMessage({
                                  ...textMessage,
                                  media: e.target.files[0],
                                  mediaDataFile: URL.createObjectURL(
                                    e.target.files[0]
                                  ),
                                });
                              }}
                            />
                          </div>
                        )}
                      {textMessage.mediaDataFile === "" && (
                        <div
                          className="gif-button-container"
                          onClick={() => setshowGIFs(true)}
                        >
                          <p className="gif-button green">GIF</p>
                        </div>
                      )}
                      {showGIFs && textMessage.gif === "" && (
                        <div className="comment-gif-input-hidden">
                          <div className="giphy-container-alt">
                            <div className="wrap-container">
                              <div className="powered-by-giphy green">
                                Powered By
                              </div>
                              <img
                                src={
                                  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                                }
                                style={{
                                  width: "80px",
                                  margin: "0px 10px",
                                }}
                                alt="logo"
                              />
                              <i
                                className="far fa-times-circle fa-lg green gif-x"
                                onClick={() => setshowGIFs(false)}
                              ></i>
                            </div>
                            <div className="gifs" id="green-scroll">
                              {!gifSearch &&
                                gifs.map((gif) => (
                                  <div
                                    className="gif-choice"
                                    onClick={(e) => {
                                      setTextMessage({
                                        ...textMessage,
                                        gif: e.target.attributes["src"].value,
                                      });
                                      inputRef.current.focus();
                                    }}
                                  >
                                    <GifItem key={gif.id} gif={gif} />
                                  </div>
                                ))}
                              {gifSearch &&
                                gifs.map((gif) => (
                                  <div
                                    className="gif-choice"
                                    onClick={(e) => {
                                      setTextMessage({
                                        ...textMessage,
                                        gif: e.target.attributes["src"].value,
                                      });
                                      inputRef.current.focus();
                                    }}
                                  >
                                    <GifItem key={gif.id} gif={gif} />
                                  </div>
                                ))}
                            </div>
                            <form
                              className="gif-input-hidden"
                              onSubmit={(e) => {
                                e.preventDefault();
                                getGifsSearch({ text });
                                setText("");
                                setGifSearch(true);
                              }}
                            >
                              <input
                                type="text"
                                className="gif-input"
                                name="text"
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                placeholder="Search for GIFs..."
                              />
                              <button
                                type="submit"
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  getGifsSearch({ text });
                                  setText("");
                                  setGifSearch(true);
                                  setshowGIFs(false);
                                }}
                                className="gif-input-button background-green"
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </div>
                      )}

                      <button
                        className="applicant-message-button background-green"
                        type="submit"
                        onClick={
                          textMessage.text !== "" ||
                          textMessage.media !== "" ||
                          textMessage.gif !== ""
                            ? (e) => {
                                e.preventDefault();
                                createMessage(textMessage, userObject.user);
                                setTextMessage({
                                  text: "",
                                  media: "",
                                  mediaDataFile: "",
                                  gif: "",
                                });
                                setshowGIFs(false);
                                inputRef.current.focus();
                              }
                            : null
                        }
                      >
                        <i className="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

MessageEmployerUsers.propTypes = {
  auth: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  getMessagesById: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  clearUsers: PropTypes.func.isRequired,
  createMessage: PropTypes.func.isRequired,
  deleteMessage: PropTypes.func.isRequired,
  deleteAllMessages: PropTypes.func.isRequired,
  deleteConversation: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  message: state.message,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getMessagesById,
  getUsers,
  clearUsers,
  createMessage,
  deleteMessage,
  deleteAllMessages,
  deleteConversation,
  getGifs,
  getGifsSearch,
})(MessageEmployerUsers);
